import { get, post } from './api'

const CredentialsService = {}

CredentialsService.getStatus = async () =>
    await get({ type: 'user', service: 'credentials/status' })

CredentialsService.sendCode = async ({ channelType, contactValue }) =>
    await post({ type: 'user', service: 'credentials/send-code', data: { channelType, contactValue } })

CredentialsService.verifyCode = async ({ channelType, code }) =>
    await post({ type: 'user', service: 'credentials/verify-code', data: { channelType, code } })

export default CredentialsService
